<template>
  <drag-dialog
    :visible.sync="visible"
    custom-class="append-dialog"
    :title="`选择检测项目`"
    width="900px"
    append-to-body
    :before-close="() => $emit('update:visible', false)"
    @close="$dialogFormReset()"
  >
    <div class="table-main">
      <div class="table-header">
        <el-form ref="searchModel" :model="searchModel" label-width="auto">
          <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
            <el-col :span="9" :offset="0">
              <el-form-item prop="remark" label="检测项目">
                <el-input
                  v-model="searchModel.remark"
                  placeholder="请输入"
                  clearable
                  @keyup.enter.native.stop="getSampleList(true)"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="15" :offset="0">
              <el-button type="success" @click="getSampleList(true)">查询</el-button>
              <el-button @click="handleReset">重置</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-table
        ref="table"
        :data="tableData"
        row-key="id"
        size="small"
        stripe
        border
        height="100%"
        v-loading="tableLoading"
        @select="handleSelection"
        @select-all="handleSelectionAll"
      >
        <el-table-column type="selection" width="55" align="center" reserve-selection></el-table-column>
        <el-table-column label="序号" align="center" width="80">
          <template v-slot="{ $index }">
            <span>{{ (searchModel.pageNum - 1) * searchModel.pageSize + $index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="testItem" label="检测项目" min-width="180" header-align="center"></el-table-column>
        <el-table-column prop="sampleCode" label="模版编号" width="140" align="center"></el-table-column>
      </el-table>

      <el-pagination
        :current-page="searchModel.pageNum"
        :page-size="searchModel.pageSize"
        background
        layout="total, prev,sizes, pager, next, jumper"
        :total="dataTotal"
        @current-change="onCurrentChange"
        @size-change="onSizeChange"
      ></el-pagination>
    </div>

    <template slot="footer">
      <el-button @click="$emit('update:visible', false)">关 闭</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确 认</el-button>
    </template>
  </drag-dialog>
</template>

<script>
import { getSampleList } from '@/api/system';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    checkedList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      searchModel: {
        remark: '',
        pageNum: 1,
        pageSize: 20
      },
      tableLoading: false,
      dataTotal: 0,
      tableData: [],
      activeSampleList: [],
      submitLoading: false
    };
  },
  computed: {},
  watch: {
    visible(val) {
      if (val) {
        this.activeSampleList = [...this.checkedList];
        this.getSampleList();
      }
    }
  },
  methods: {
    handleReset() {
      this.$refs.searchModel.resetFields();
      this.getSampleList(true);
    },
    onCurrentChange(pageNum) {
      this.searchModel.pageNum = pageNum;
      this.getSampleList();
    },
    onSizeChange(pageSize) {
      this.searchModel.pageSize = pageSize;
      this.getSampleList(true);
    },
    async getSampleList(isFirstPage = false) {
      if (isFirstPage) this.searchModel.pageNum = 1;

      this.tableLoading = true;
      const { data } = await getSampleList(this.searchModel);

      this.tableData = data.list || [];
      this.tableData.map(item => {
        item.itemId = item.id;
      });
      // 绑定已选中数据
      this.$nextTick(() => {
        this.tableData.forEach(row => {
          const selected = this.activeSampleList.some(activeItem => activeItem.itemId === row.itemId);
          this.$refs.table.toggleRowSelection(row, selected);
        });
      });
      this.dataTotal = data.count || 0;
      this.tableLoading = false;
    },

    // 操作
    handleSelection(_, row) {
      const activeIndex = this.activeSampleList.findIndex(item => item.itemId === row.itemId);
      activeIndex > -1 ? this.activeSampleList.splice(activeIndex, 1) : this.activeSampleList.push(row);
    },
    handleSelectionAll(val) {
      if (val.length > 0) {
        val.forEach(row => {
          const activeIndex = this.activeSampleList.findIndex(item => item.itemId === row.itemId);
          if (activeIndex == -1) this.activeSampleList.push(row);
        });
      } else {
        this.tableData.forEach(row => {
          const activeIndex = this.activeSampleList.findIndex(item => item.itemId === row.itemId);
          if (activeIndex > -1) this.activeSampleList.splice(activeIndex, 1);
        });
      }
    },
    async handleSubmit() {
      this.$emit('setItemList', this.activeSampleList);
      this.$emit('update:visible', false);
    }
  },
  created() {},
  mounted() {}
};
</script>

<style lang="scss" scoped>
.table-main {
  height: 500px;
}
</style>
